'use es6';

import { DropTarget } from 'react-dnd';
import DragTypes from 'simple-menus-core/enums/DragTypes';
const target = {
  canDrop(props) {
    return !props.isParentDragging;
  },
  drop(props, monitor) {
    if (monitor.didDrop()) return;
    props.moveNode(monitor.getItem());
  }
};
export default function menuDropTarget() {
  return Component => {
    return DropTarget(DragTypes.ADVANCED_MENUS_MENU_NODE, target, (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    }))(Component);
  };
}